import React from "react";
import ActivitiesComponent from "../components/Activities";
import NavBar from "../components/NavBar";

const Activities = () => {
  return (
    <>
      <NavBar id="activities" />
      <ActivitiesComponent />
    </>
  );
};

export default Activities;
